import _ from 'lodash';
import React, { useCallback } from 'react';
import { PropTypes } from '~/utils';
import { useSpatialNav } from '~/hooks';
import { useGlobalContext, useStation } from '~/context';

export function IdleWrapper( { children } ) {
  const station = useStation();
  const { dispatch } = useGlobalContext();

  const cb = useCallback( ( key, ev, spatial ) => {
    if ( key === ' ' ) {
      dispatch.overlay( 'MoreOptionsOverlay' );
      return true;
    }
  }, [ dispatch ] );
  useSpatialNav( cb );

  return (
    <div className="idle h-100">
      {children}
      <small className="corner br">[{station.id}]</small>
    </div>
  );
}
IdleWrapper.propTypes = {
  children  : PropTypes.node.isRequired,
};
